// 公共请求
import $http from '../utils/ajax';
import Vue from 'vue';
import store from '@/store/index';
import {toast} from 'veui';
Vue.use(toast);

/**
 *  获取页面信息上一次更新的时间戳通用接口，用于更新菜单上的红点（如课程上新后展示红点，点击菜单后红点消失等功能）
 */
export const getTabNews = () => {
    return new Promise((resolve, reject) => {
        $http
            .get('/bp/common/gettabnews')
            .then(res => {
                if (!res || +res.code !== 0 || !res.data) {
                    reject();
                    return;
                }
                let info = res.data.tab_news || {};
                let nums = res.data.tab_nums || {};
                resolve({info, nums});
            })
            .catch(() => {
                reject();
            });
    });
};

// 授权方法
export const authorize = () => {
    return new Promise((resolve, reject) => {
        $http
            .post('/bp/api/vip/genvip')
            .then(res => {
                if (+res?.code === 0) {
                    resolve(res);
                }
                else {
                    toast.error(res?.msg || '授权失败，请稍候再试~');
                    reject(res);
                }
            }).catch(() => {
                toast.error('授权失败，请稍候再试~');
                reject();
            });
    });
};

// 免费体验会员领取
export const receiveVip = params => {
    return new Promise((resolve, reject) => {
        $http
            .post('/bp/api/vip/trialvip/receive', {
                ...params
            })
            .then(res => {
                if (+res?.code === 0) {
                    setTimeout(() => {
                        resolve(res);
                        store && store.dispatch('lawStore/getVipInfo');
                    }, 1000);
                }
                else {
                    toast.error(res?.msg || '领取失败，请稍候再试~');
                    reject(res);
                }
            }).catch(() => {
                toast.error('领取失败，请稍候再试~');
                reject();
            });
    });
};